import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import PanoramaMobile from "./PanoramaMobile";
import PanoramaDesktop from "./PanoramaDesktop";

function Panorama({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

	return isMobile ? (
		<PanoramaMobile app={app} config={config} />
	) : (
		<PanoramaDesktop app={app} config={config} />
	);
}

Panorama.defaultProps = {
	app: null,
	config: {},
};

Panorama.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Panorama;
